<div *ngIf="!studyStartedToday" class="py-4">
	<div [ngClass]="{ 'full-mode': !forPrint, 'compact-mode': forPrint }">
		<div class="input-group p-0 mr-3">
			<div class="input-group-prepend">
				<span class="input-group-text">{{ 'g.start_date' | translate }}</span>
			</div>
			<input
				class="form-control"
				[ngClass]="{ 'text-danger': invalidDateRange }"
				[minDate]="minStartDate"
				[maxDate]="maxStartDate"
				placeholder="mm/dd/yyyy"
				name="studyStartDB"
				[(ngModel)]="startDate"
				(ngModelChange)="onDatesChanged()"
				bsDatepicker
				#studyStartDB="bsDatepicker"
				[bsConfig]="{ containerClass: 'theme-dark-blue' }"
			/>
			<div class="input-group-append pointer" (click)="studyStartDB.toggle()">
				<span class="input-group-text"><i class="fa fa-calendar"></i></span>
			</div>
		</div>

		<div class="input-group p-0 mr-3">
			<div class="input-group-prepend">
				<span class="input-group-text">{{ 'g.end_date' | translate }}</span>
			</div>
			<input
				class="form-control"
				[ngClass]="{ 'text-danger': invalidDateRange }"
				[minDate]="minEndDate"
				[maxDate]="maxEndDate"
				placeholder="mm/dd/yyyy"
				name="studyEndDB"
				[(ngModel)]="endDate"
				(ngModelChange)="onDatesChanged()"
				bsDatepicker
				#studyEndDB="bsDatepicker"
				[bsConfig]="{ containerClass: 'theme-dark-blue' }"
			/>
			<div class="input-group-append pointer" (click)="studyEndDB.toggle()">
				<span class="input-group-text"><i class="fa fa-calendar"></i></span>
			</div>
		</div>

		<div class="p-0" [ngClass]="{ 'col-4': !forPrint, 'col-12': forPrint }">
			<ng-select
				class="select full-width"
				[searchable]="false"
				[clearable]="false"
				[items]="daysFilters"
				bindLabel="label"
				bindValue="value"
				[(ngModel)]="workingDays"
				(change)="onWorkingDaysChanged()"
			></ng-select>
		</div>
	</div>
</div>